import Table from "../../Components/Table";
import StatusHandler from "../../Components/Table/StatusHandler";
import useFetchData from "../../Hooks/useFetchData";
import useTableControls from "../../Hooks/useTableControls";
import { getEarnings } from "../../Services/Earning";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import PageHeader from "../../Components/PageHeader";

export default function Earnings() {
  // const sampleData = [
  //   {
  //     sn: "1",
  //     postedBy: "Abc User",
  //     mover: "Abc Mover",
  //     datePosted: "01/02/2022",
  //     cost: "000",
  //     moverCommission: "000",
  //     adminCommission: "000",
  //     jobStatus: "pending",
  //   },
  //   {
  //     sn: "2",
  //     postedBy: "Abc User",
  //     mover: "Abc Mover",
  //     datePosted: "01/02/2022",
  //     cost: "000",
  //     moverCommission: "000",
  //     adminCommission: "000",
  //     jobStatus: "rejected",
  //   },
  //   {
  //     sn: "3",
  //     postedBy: "Abc User",
  //     mover: "Abc Mover",
  //     datePosted: "01/02/2022",
  //     cost: "000",
  //     moverCommission: "000",
  //     adminCommission: "000",
  //     jobStatus: "completed",
  //   },
  //   {
  //     sn: "4",
  //     postedBy: "Abc User",
  //     mover: "Abc Mover",
  //     datePosted: "01/02/2022",
  //     cost: "000",
  //     moverCommission: "000",
  //     adminCommission: "000",
  //     jobStatus: "ongoing",
  //   },
  //   {
  //     sn: "5",
  //     postedBy: "Abc User",
  //     mover: "Abc Mover",
  //     datePosted: "01/02/2022",
  //     cost: "000",
  //     moverCommission: "000",
  //     adminCommission: "000",
  //     jobStatus: "pending",
  //   },
  // ];

  const {
    perPage,
    setPerPage,
    status,
    setStatus,
    search_string,
    setSearchString,
    from,
    setFrom,
    to,
    setTo,
  } = useTableControls();

  const {
    // INTERNAL EXPORTS
    page,
    setPage,
    // REACT QUERY EXPORTS
    isFetching,
    isLoading,
    data,
    refetch,
  } = useFetchData("earning-logs", getEarnings, [
    perPage,
    search_string,
    status,
    from,
    to,
  ]);
  // console.log("earning-logs Data: ", data?.data);

  return (
    <div className="app-content content">
      <div className="content-wrapper">
        <div className="content-body">
          {/* Basic form layout section start */}
          <section id="configuration">
            <div className="row">
              <div className="col-12">
                <div className="user-details-wrapper">
                  <PageHeader
                    title="Earnings"
                    subtitle="Monitor platform revenue, driver payouts, and commission reports"
                  />
                  <div className="row mb-4">
                    <div className="col-xl-4 col-md-6 mb-3">
                      <div className="dashCard h-100">
                        <div className="totalInfo d-block text-center py-4">
                          <p className="totalLabel mb-2">Total Earning</p>
                          <h3 className="totalValue display-5 mb-0">
                            {data?.data?.data?.totalEarnings
                              ? `$${data?.data?.data?.totalEarnings?.toFixed(2)}`
                              : `$${0}`}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 mb-3">
                      <div className="dashCard h-100 border-start-0">
                        <div className="totalInfo d-block text-center py-4">
                          <p className="totalLabel mb-2">Week's Earning</p>
                          <h3 className="totalValue display-5 mb-0" style={{ color: '#0ea5e9' }}>
                            {data?.data?.data?.weekEarnings
                              ? `$${data?.data?.data?.weekEarnings?.toFixed(2)}`
                              : `$${0}`}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-6 mb-3">
                      <div className="dashCard h-100">
                        <div className="totalInfo d-block text-center py-4">
                          <p className="totalLabel mb-2">Today's Earning</p>
                          <h3 className="totalValue display-5 mb-0" style={{ color: '#10b981' }}>
                            {data?.data?.data?.todayEarnings
                              ? `$${data?.data?.data?.todayEarnings?.toFixed(2)}`
                              : `$${0}`}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Table
                    key={"earnings-table"}
                    lastColumnIsAction={false}
                    tableTitles={[
                      "S.No.",
                      "Posted By",
                      "Driver Name",
                      "Date Posted",
                      "Cost",
                      // "Admin Amount",
                      // "Mover Commission",
                      "Admin Commission",
                      // "Job Status",
                      // "Action",
                    ]}
                    dateFilter
                    showEntries
                    // sortBy
                    isLoading={isLoading}
                    isFetching={isFetching}
                    data={data?.data?.data?.docs}
                    totalPages={Math.ceil(data?.data?.data?.totalPages || 0)}
                    totalDocs={data?.data?.data?.totalDocs}
                    page={page}

                    setPage={setPage}
                    setSearchString={setSearchString}
                    status={status}
                    setStatus={setStatus}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    from={from}
                    setFrom={setFrom}
                    to={to}
                    setTo={setTo}
                  >
                    {data?.data?.data?.docs?.map((item, index) => (
                        <tr key={item?._id || index}>
                          <td>{getSerialNumber(data?.data?.data, index)}</td>
                          <td>{item?.user?.firstName}</td>
                          <td>{item?.driver?.firstName}</td>
                          <td>
                            {item?.createdAt &&
                              format_date(item?.createdAt, "MM/DD/YYYY")}
                          </td>
                          <td>
                            {item?.bookingDetails?.price &&
                              `$${item?.bookingDetails?.price?.toFixed(2)}`}
                          </td>
                          {/* <td>${item.moverCommission}</td> */}
                          <td>
                            {item?.bookingDetails?.adminEarnedAmount &&
                              `$${item?.bookingDetails?.adminEarnedAmount?.toFixed(
                                2
                              )}`}
                          </td>
                          {/* <td>
                            {item?.bookingDetails?.adminCommission &&
                              `${item?.bookingDetails?.adminCommission}%`}
                          </td> */}
                          {/* <td>{item?.status}</td> */}
                          {/* <td>
                            <StatusHandler
                              key={`${item?._id}-status`}
                              view
                              redirectUrl={`/earnings/earning-details/${item?._id}`}
                            />
                          </td> */}
                        </tr>
                      ))}
                  </Table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
            <style>{`
                .fw-800 { font-weight: 800; }
                .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                
                @media (max-width: 576px) {
                    .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                    .user-details-wrapper { padding: 0.5rem; }
                }
            `}</style>
    </div>
  );
}
